import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ROOT_STATE_SERVICES } from '@appState';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  CuiAppContainerComponent,
  CuiCardModule,
  CuiDatepickerComponent,
  CuiLibraryModule,
  CuiPageTitleComponent,
  CuiSideNavModule,
  CuiTopMenuModule,
} from 'cui-components';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticatedTemplateComponent } from './components/authenticated-template/authenticated-template.component';
import { MainComponent } from './components/main/main.component';
import {
  AppConfigService,
  AppInsightsLoggingService,
  DateHttpInterceptor,
  GlobalErrorHandler,
  HttpErrorInterceptor,
  HttpHighlanderInterceptor,
  loggingInitializer,
} from './infrastructure';

@NgModule({
  declarations: [MainComponent, AuthenticatedTemplateComponent],
  bootstrap: [MainComponent],
  imports: [
    CuiAppContainerComponent,
    CuiLibraryModule.forRoot({ apiUrl: environment.bffUrl, enableHttpOperationTracking: true, enableFileUploadTracking: true }),
    CuiTopMenuModule,
    CuiSideNavModule,
    CuiPageTitleComponent,
    MatTooltipModule,
    AppRoutingModule,
    MatSnackBarModule,
    MatSidenavModule,
    NgSelectModule,
    BrowserAnimationsModule,
    MatDialogModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CuiCardModule,
    CuiDatepickerComponent, // Required for datepicker to work in the application
    MatSelectModule,
  ],
  providers: [
    ...ROOT_STATE_SERVICES,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'dynamic' } as MatFormFieldDefaultOptions,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DateHttpInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHighlanderInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = loggingInitializer(inject(AppConfigService), inject(AppInsightsLoggingService));
      return initializerFn();
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
